import Loader from './Loader/Loader';
const Loading = () => {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <Loader size="lg" color="primary" />
    </div>
  );
};

export default Loading;
